import { YEAR_IN_REVIEW_MODAL_COMPONENT, yearInReviewModalComponentDef } from 'navigation-components/config';
import { useComponentProps, useToggleComponent } from 'navigation-components/platform/hooks';
import { useEffect, useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectYearInReviewModalEnabled } from '../selectors/year-in-review.selectors';
export const useYearInReviewQueryParams = () => {
  const {
    toggle
  } = useToggleComponent(YEAR_IN_REVIEW_MODAL_COMPONENT);
  const updateNavComponentProps = useComponentProps(yearInReviewModalComponentDef);
  const {
    location: {
      search,
      pathname
    },
    history
  } = window;
  const isYearInReviewModalEnabled = useAppSelector(selectYearInReviewModalEnabled);
  const urlQueryParams = useMemo(() => new URLSearchParams(search || ''), [search]);
  const shouldOpenYearInReviewModalByQueryParam = urlQueryParams.get('openReview') === 'true';
  useEffect(() => {
    if (shouldOpenYearInReviewModalByQueryParam && isYearInReviewModalEnabled) {
      updateNavComponentProps({
        source: 'queryParam'
      });
      toggle(true);

      // cleanup "openReview" query param from URL
      urlQueryParams.delete('openReview');
      const serialized = urlQueryParams.toString();
      const paramString = serialized === '' ? pathname : `?${serialized}`;
      history.replaceState({}, '', paramString);
    }
  }, [history, isYearInReviewModalEnabled, pathname, shouldOpenYearInReviewModalByQueryParam, toggle, updateNavComponentProps, urlQueryParams]);
};